// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--30222";
export var content_box = "index-module--content_box--a9607";
export var custom_row = "index-module--custom_row--ae2f0";
export var meeting_room_content = "index-module--meeting_room_content--f4e4e";
export var team_sizes = "index-module--team_sizes--c7cca";
export var titleFont = "index-module--title-font--bd70e";